import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import InputField from '../InputField'
import type { InputFieldProps } from '../InputField'
import { useIsMobile } from '../../hooks'
import Spinner from '../Spinner'
import { useTranslation } from '../../providers/TranslationProvider'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(2, 2, 1, 2)
  },
  input: {
    paddingLeft: 0
  },
  icon: {
    color: theme.paintscout.palette.brand.Neutral.P80
  }
}))

export interface DropdownSelectSearchBarProps extends Omit<InputFieldProps, 'onChange'> {
  onChange: (value: string) => void
  placeholder?: string
  loading?: boolean
}

export default function DropdownSelectSearchBar({
  placeholder,
  onChange,
  loading,
  ...inputProps
}: DropdownSelectSearchBarProps) {
  const classes = useStyles()
  const mobile = useIsMobile()
  const { __ } = useTranslation()

  return (
    <div className={classes.container}>
      <InputField
        {...inputProps}
        classes={{
          input: classes.input
        }}
        fullWidth
        startAdornment={loading ? <Spinner size={20} /> : <SearchIcon className={classes.icon} />}
        placeholder={placeholder ?? __('Search')}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={!mobile}
      />
    </div>
  )
}
